import styled from "styled-components";

export const Styles = styled.div`
  .field-section {
    .ant-checkbox + span {
      /* font-size: 1rem; */
    }
    span.required-mark {
      margin-left: 4px;
      color: #e74c3c;
      font-size: 20px;
    }
    /* label.label {
      font-size: 1rem;
      span {
        margin-left: 4px;
        color: #e74c3c;
        font-size: 20px;
      }
    } */
  }
`;
